import type { ReactNode } from 'react';

export const symbol_night_sight_auto: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M440-190q59 0 110.5-27.5T641-290q-129-8-220-95.5T330-600q0-17 2.5-34.5T338-669q-65 36-106.5 96T190-440q0 104.17 72.92 177.08Q335.83-190 440-190Zm0 60q-129 0-219.5-90.5T130-440q0-54.8 19-104.4 19-49.6 52-89.6 33-40 79-68t100-40q18-4 29.5 12t1.5 34q-12 22-16.5 46.49Q390-625.03 390-600q0 104.17 72.92 177.08Q535.83-350 640-350q11 0 21-.5t21.27-3.77Q702-360 716-344.5q14 15.5 5 34.5-38 82-114 131t-167 49Zm218-474-20 56.84Q634-536 625.31-530T606-524q-17 0-27.5-14t-4.55-31l101.09-287q3.96-11 13.65-17.5 9.69-6.5 21.31-6.5h26q12 0 21.58 6.72 9.59 6.72 13.42 17.28l101.06 287q5.94 17-4.56 31T840-524q-10.67 0-19.39-6.23-8.73-6.23-12.61-16.77l-20.27-57H658Zm16-50h98l-49-155-49 155ZM421-387Z"
		/>
	</svg>
);
